import CommonService from "../../services/CommonService";
import NodeLockPannelService from "../../services/NodeLockPannelService";
import RemarkService from "../../services/RemarkService";
export default {
  namespaced: true,
  state: {
    pendingReverseTallyList: [],
    pendingReverseTallyExcel: [],
    allMultiLeadUserList: [],
    allLeadCompList: [],
    allLeadUserList: [],
    allUserList: [],
    allMultiUserList: [],
    allMultiContractList: [],
    allStateList: [],
    allCityList: [],
    allCurrencyList: [],
    allAgentColoaderList: [],
    allColoaderList: [],
    allBranchList: [],
    allMultiBranchList: [],
    allFilterBranchList: [],
    allBranchOfficeList: [],
    allLedgerList: [],
    allBillingLocationList: [],
    allClientList: [],
    allMultiClientList: [],
    allShippingLineList: [],
    allConsigneeList: [],
    allConsignorList: [],
    allAirLineList: [],
    allUnitList: [],
    allContainerTypeList: [],
    allSplitedOrMergedContainersList: [],

    allAirPortDepartureList: [],
    allAirPortDestinationList: [],

    allLocationDetailsFinalList: [],
    allPORList: [],
    allPODList: [],
    allPOLList: [],

    allContractList: [],
    allContractBasedVesselList: [],

    allSuccessInvoiceTB: [],
    allRemarkDDList: [],
  },
  getters: {
    getAllPendingReverseTallyList: (state) => state.pendingReverseTallyList,
    getAllPendingReverseTallyExcel: (state) => state.pendingReverseTallyExcel,
    getAllCurrencyList: (state) => state.allCurrencyList,
    getAllCityList: (state) => state.allCityList,
    getAllStateList: (state) => state.allStateList,
    getAllUserList: (state) => state.allUserList,
    getAllLeadCompList: (state) => state.allLeadCompList,
    getAllMultiUserList: (state) => state.allMultiUserList,
    getAllMultiContractList: (state) => state.allMultiContractList,
    getAllLeadUserList: (state) => state.allLeadUserList,
    getAllMultiLeadUserList: (state) => state.allMultiLeadUserList,
    getAllAgentColoaderList: (state) => state.allAgentColoaderList,
    getAllColoaderList: (state) => state.allColoaderList,
    getAllBranchList: (state) => state.allBranchList,
    getAllConsigneeList: (state) => state.allConsigneeList,
    getAllConsignorList: (state) => state.allConsignorList,
    getAllMultiBranchList: (state) => state.allMultiBranchList,
    getAllFilterBranchList: (state) => state.allFilterBranchList,
    getAllBranchOfficeList: (state) => state.allBranchOfficeList,
    getAllLedgerList: (state) => state.allLedgerList,
    getAllBillingLocationList: (state) => state.allBillingLocationList,
    getAllClientList: (state) => state.allClientList,
    getAllMultiClientList: (state) => state.allMultiClientList,
    getAllLeadClientList: (state) => state.allLeadClientList,
    getAllShippingLineList: (state) => state.allShippingLineList,
    getAllDocumentTypeList: (state) => state.allDocumentTypeList,

    getAllModuleList: (state) => state.allModuleList,
    getAllSubModuleList: (state) => state.allSubModuleList,

    getAllAirLineList: (state) => state.allAirLineList,
    getAllUnitList: (state) => state.allUnitList,
    getAllContainerTypeList: (state) => state.allContainerTypeList,
    getAllSplitedOrMergedContainersList: (state) =>
      state.allSplitedOrMergedContainersList,

    getAllAirPortDepartureList: (state) => state.allAirPortDepartureList,
    getAllAirPortDestinationList: (state) => state.allAirPortDestinationList,

    getAllLocationDetailsFinalList: (state) =>
      state.allLocationDetailsFinalList,
    getAllPORList: (state) => state.allPORList,
    getAllPODList: (state) => state.allPODList,
    getAllPOLList: (state) => state.allPOLList,
    getAllContractList: (state) => state.allContractList,
    getAllContractBasedVesselList: (state) => state.allContractBasedVesselList,
    getAllSuccessInvoiceTB: (state) => state.allSuccessInvoiceTB,
    getAllRemarkDDList: (state) => state.allRemarkDDList,
  },
  mutations: {
    SET_PENDING_REVERSE_TALLY_COUNT(state, val) {
      state.pendingReverseTallyList = val;
    },
    SET_PENDING_REVERSE_TALLY_EXCEL(state, val) {
      state.pendingReverseTallyExcel = val;
    },
    SET_ALL_CURRENCY_LIST(state, val) {
      state.allCurrencyList = val;
    },
    SET_ALL_CITY_LIST(state, val) {
      state.allCityList = val;
    },
    SET_ALL_State_LIST(state, val) {
      state.allStateList = val;
    },
    SET_ALL_LEAD_COMP_LIST(state, val) {
      state.allLeadCompList = val;
    },
    SET_ALL_USER_LIST(state, val) {
      state.allUserList = val;
    },
    SET_ALL_MULTI_USER_LIST(state, val) {
      state.allMultiUserList = val;
    },
    SET_ALL_MULTI_CONTRACT_LIST(state, val) {
      state.allMultiContractList = val;
    },
    SET_ALL_LEAD_USER_LIST(state, val) {
      state.allLeadUserList = val;
    },
    SET_ALL_MULTI_LEAD_USER_LIST(state, val) {
      state.allMultiLeadUserList = val;
    },
    SET_ALL_AGENT_COLODER_LIST(state, val) {
      state.allAgentColoaderList = val;
    },
    SET_ALL_COLODER_LIST(state, val) {
      state.allColoaderList = val;
    },
    SET_ALL_BRANCH_LIST(state, val) {
      state.allBranchList = val;
    },
    SET_ALL_MULTI_BRANCH_LIST(state, val) {
      state.allMultiBranchList = val;
    },
    SET_ALL_FILTER_BRANCH_LIST(state, val) {
      state.allFilterBranchList = val;
    },
    SET_ALL_BRANCH_OFFICE_LIST(state, val) {
      state.allBranchList = val;
    },
    SET_ALL_LEDGER_LIST(state, val) {
      state.allLedgerList = val;
    },
    SET_ALL_BILLING_LOCATION_LIST(state, val) {
      state.allBillingLocationList = val;
    },
    SET_ALL_CLIENT_LIST(state, val) {
      state.allClientList = val;
    },
    SET_ALL_MULTI_CLIENT_LIST(state, val) {
      state.allMultiClientList = val;
    },
    SET_ALL_CONSIGNEE_LIST(state, val) {
      state.allConsigneeList = val;
    },
    SET_ALL_CONSIGNOR_LIST(state, val) {
      state.allConsignorList = val;
    },
    SET_ALL_LEAD_CLIENT_LIST(state, val) {
      state.allLeadClientList = val;
    },
    SET_ALL_SHIPPING_LINE_LIST(state, val) {
      state.allShippingLineList = val;
    },
    SET_ALL_DOCUMENT_TYPE_LIST(state, val) {
      state.allDocumentTypeList = val;
    },
    SET_ALL_MODULE_LIST(state, val) {
      state.allModuleList = val;
    },
    SET_ALL_SUB_MODULE_LIST(state, val) {
      state.allSubModuleList = val;
    },
    SET_ALL_AIR_LINE_LIST(state, val) {
      state.allAirLineList = val;
    },

    SET_ALL_UNIT_LIST(state, val) {
      state.allUnitList = val;
    },
    SET_ALL_CONTAINER_TYPE_LIST(state, val) {
      state.allContainerTypeList = val;
    },
    SET_ALL_SPLIT_OR_MERGE_CONTAINER_LIST(state, val) {
      state.allSplitedOrMergedContainersList = val;
    },

    SET_ALL_AIRPORT_DEPARTURE_LIST(state, val) {
      state.allAirPortDepartureList = val;
    },
    SET_ALL_AIRPORT_DESIGNATION_LIST(state, val) {
      state.allAirPortDestinationList = val;
    },

    SET_ALL_LOCATION_DETAILS_FINAL_LIST(state, val) {
      state.allLocationDetailsFinalList = val;
    },

    SET_ALL_POR_LIST(state, val) {
      state.allPORList = val;
    },
    SET_ALL_POD_LIST(state, val) {
      state.allPODList = val;
    },
    SET_ALL_POL_LIST(state, val) {
      state.allPOLList = val;
    },
    SET_ALL_CONTRACT_LIST(state, val) {
      state.allContractList = val;
    },

    SET_ALL_CONTRACT_VESSEL_LIST(state, val) {
      state.allContractBasedVesselList = val;
    },

    SET_ALL_SUCCESS_INVOICE_TB(state, val) {
      state.allSuccessInvoiceTB = val;
    },
    SET_ALL_REMARK_DD_LIST(state, val) {
      state.allRemarkDDList = val;
    },
  },
  actions: {
    setAllPendingReverseTallyList: async (
      { dispatch, commit, state },
      payload,
    ) => {
      await commit("SET_PENDING_REVERSE_TALLY_COUNT", []);
      CommonService.getAllPendingReverseTallyList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.ReverseTallyNotExistcount
          ) {
            await commit(
              "SET_PENDING_REVERSE_TALLY_COUNT",
              response.data.ReverseTallyNotExistcount,
            );
          } else {
            console.log(response.data);
          }
          console.log("getAllPendingReverseTallyList", response.data, payload);
        })
        .catch((err) => {
          console.log("Error in getting getAllPendingReverseTallyList ", err);
        });
    },
    setAllPendingReverseTallyExcel: async (
      { dispatch, commit, state },
      payload,
    ) => {
      await commit("SET_PENDING_REVERSE_TALLY_EXCEL", []);
      CommonService.getAllPendingReverseTallyList(payload)
        .then(async (response) => {
          if (response.status == 200 && response.data) {
            await commit(
              "SET_PENDING_REVERSE_TALLY_EXCEL",
              response.data.excelName,
            );
            if (response.data.excelName) {
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` +
                response.data.excelName;
            }
          } else {
            console.log(response);
          }
          console.log("getAllPendingReverseTallyExcel", response, payload);
        })
        .catch((err) => {
          console.log("Error in getting getAllPendingReverseTallyExcel ", err);
        });
    },
    setAllCurrencyList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_CURRENCY_LIST", []);
      CommonService.getAllCurrencyList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.CurrencyList
          ) {
            await commit("SET_ALL_CURRENCY_LIST", response.data.CurrencyList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllCurrencyList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllCurrencyList ", err);
        });
    },
    setAllStateList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_State_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.StateList
          ) {
            await commit("SET_ALL_State_LIST", response.data.StateList);
          } else {
            // console.log(response.data);
          }
          // console.log("getallStateList", response);
        })
        .catch((err) => {
          console.log("Error in getting getallStateList ", err);
        });
    },
    setAllLeadCompList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_LEAD_COMP_LIST", []);
      CommonService.getAllUserList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.LEADCompList
          ) {
            await commit("SET_ALL_LEAD_COMP_LIST", response.data.LEADCompList);
          } else {
            // console.log(response.data);
          }
          // console.log("AllLeadCompList", response);
        })
        .catch((err) => {
          console.log("Error in getting AllLeadCompList ", err);
        });
    },
    setAllUserList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_USER_LIST", []);
      CommonService.getAllUserList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.UserList
          ) {
            await commit("SET_ALL_USER_LIST", response.data.UserList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllUserList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllUserList ", err);
        });
    },
    setAllMultiUserList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_MULTI_USER_LIST", []);
      CommonService.getAllUserList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.UserList
          ) {
            await commit("SET_ALL_MULTI_USER_LIST", response.data.UserList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllMultiUserList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllUserList ", err);
        });
    },
    setAllMultiContractList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_MULTI_CONTRACT_LIST", []);
      CommonService.getAllUserList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.ContractList
          ) {
            await commit(
              "SET_ALL_MULTI_CONTRACT_LIST",
              response.data.ContractList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getAllMultiContractList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllMultiContractList ", err);
        });
    },
    setAllLeadUserList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_LEAD_USER_LIST", []);
      CommonService.getAllUserList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.LEADUserList
          ) {
            await commit("SET_ALL_LEAD_USER_LIST", response.data.LEADUserList);
          } else {
            // console.log(response.data);
          }
          // console.log("AllLeadUserList", response);
        })
        .catch((err) => {
          console.log("Error in getting AllLeadUserList ", err);
        });
    },
    setAllMultiLeadUserList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_MULTI_LEAD_USER_LIST", []);
      CommonService.getAllUserList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.LEADUserList
          ) {
            await commit(
              "SET_ALL_MULTI_LEAD_USER_LIST",
              response.data.LEADUserList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("AllLeadUserList", response);
        })
        .catch((err) => {
          console.log("Error in getting AllMultiLeadUserList ", err);
        });
    },
    setAllCityList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_CITY_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.CityList
          ) {
            await commit("SET_ALL_CITY_LIST", response.data.CityList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllCityList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllCityList ", err);
        });
    },
    setAllAgentColoaderList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_AGENT_COLODER_LIST", []);
      CommonService.getAllAgentColoaderList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.agentColoaderList
          ) {
            await commit(
              "SET_ALL_AGENT_COLODER_LIST",
              response.data.agentColoaderList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getAllAgentColoaderList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllAgentColoaderList ", err);
        });
    },
    setAllColoaderList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_COLODER_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.ColoderList
          ) {
            await commit("SET_ALL_COLODER_LIST", response.data.ColoderList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllColoaderList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllColoaderList ", err);
        });
    },
    setAllBranchList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_BRANCH_LIST", []);
      CommonService.getAllBranchList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.BranchList
          ) {
            await commit("SET_ALL_BRANCH_LIST", response.data.BranchList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllBranchOfficeList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllBranchOfficeList ", err);
        });
    },
    setAllFilterBranchList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_FILTER_BRANCH_LIST", []);
      CommonService.getAllBranchList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getFilterBranchList
          ) {
            await commit(
              "SET_ALL_FILTER_BRANCH_LIST",
              response.data.getFilterBranchList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getFilterBranchList", response);
        })
        .catch((err) => {
          console.log("Error in getting getFilterBranchList ", err);
        });
    },
    setAllMultiBranchList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_MULTI_BRANCH_LIST", []);
      CommonService.getAllMultiBranchList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.MultiBranchList
          ) {
            await commit(
              "SET_ALL_MULTI_BRANCH_LIST",
              response.data.MultiBranchList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getAllMultiBranchList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllMultiBranchList ", err);
        });
    },
    setAllBranchOfficeList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_BRANCH_OFFICE_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.BranchOfficeList
          ) {
            await commit(
              "SET_ALL_BRANCH_OFFICE_LIST",
              response.data.BranchOfficeList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getAllBranchOfficeList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllBranchOfficeList ", err);
        });
    },
    setAllLedgerList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_LEDGER_LIST", []);
      CommonService.getAllLedgerList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.LedgerList
          ) {
            await commit("SET_ALL_LEDGER_LIST", response.data.LedgerList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllLedgerList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllLedgerList ", err);
        });
    },
    setAllBillingLocationList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_BILLING_LOCATION_LIST", []);
      CommonService.getAllBillingLocationList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.BillingLocationList
          ) {
            await commit(
              "SET_ALL_BILLING_LOCATION_LIST",
              response.data.BillingLocationList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getAllBillingLocationList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllBillingLocationList ", err);
        });
    },
    setAllClientList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_CLIENT_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.ClientList
          ) {
            await commit("SET_ALL_CLIENT_LIST", response.data.ClientList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllConsigneeList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllClientList ", err);
        });
    },
    setAllMultiClientList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_MULTI_CLIENT_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.ClientList
          ) {
            await commit("SET_ALL_MULTI_CLIENT_LIST", response.data.ClientList);
          } else {
            // console.log(response.data);
          }
        })
        .catch((err) => {
          console.log("Error in getting getAllMultiClientList ", err);
        });
    },

    setAllConsigneeList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_CONSIGNEE_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.ConsigneeList
          ) {
            await commit("SET_ALL_CONSIGNEE_LIST", response.data.ConsigneeList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllConsigneeList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllConsigneeList ", err);
        });
    },
    setAllConsignorList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_CONSIGNOR_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.ConsignorList
          ) {
            await commit("SET_ALL_CONSIGNOR_LIST", response.data.ConsignorList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllConsignorList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllConsignorList ", err);
        });
    },
    setAllLeadClientList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_LEAD_CLIENT_LIST", []);
      CommonService.getAllLeadClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.LeadClientList
          ) {
            console.log("SET_ALL_LEAD_CLIENT_LIST=>", response.data);
            await commit(
              "SET_ALL_LEAD_CLIENT_LIST",
              response.data.LeadClientList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getAllLeadClientList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllLeadClientList ", err);
        });
    },
    setAllShippingLineList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_SHIPPING_LINE_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.ShippingLineList
          ) {
            await commit(
              "SET_ALL_SHIPPING_LINE_LIST",
              response.data.ShippingLineList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getAllShippingLineList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllShippingLineList ", err);
        });
    },
    setAllDocumentTypeList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_DOCUMENT_TYPE_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.DocumentTypeList
          ) {
            await commit(
              "SET_ALL_DOCUMENT_TYPE_LIST",
              response.data.DocumentTypeList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getAllDocumentTypeList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllDocumentTypeList ", err);
        });
    },
    setAllModuleList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_MODULE_LIST", []);
      CommonService.getAllCommonMaster(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.ModuleList
          ) {
            await commit("SET_ALL_MODULE_LIST", response.data.ModuleList);
          } else {
            // console.log(response.data);
          }
          // console.log("setAllModuleList", response);
        })
        .catch((err) => {
          console.log("Error in getting setAllModuleList ", err);
        });
    },
    setAllSubModuleList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_SUB_MODULE_LIST", []);
      CommonService.getAllCommonMaster(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.SubModuleList
          ) {
            await commit(
              "SET_ALL_SUB_MODULE_LIST",
              response.data.SubModuleList,
            );
            console.log("SET_ALL_SUB_MODULE_LIST", response.data.SubModuleList);
          } else {
            // console.log(response.data);
          }
          // console.log("setAllSubModuleList", response);
        })
        .catch((err) => {
          console.log("Error in getting setAllSubModuleList ", err);
        });
    },
    setAllAirLineList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_AIR_LINE_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.AirLineList
          ) {
            await commit("SET_ALL_AIR_LINE_LIST", response.data.AirLineList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllAirLineList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllAirLineList ", err);
        });
    },
    setAllUnitList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_UNIT_LIST", []);
      CommonService.getAllUnitList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.UnitList
          ) {
            await commit("SET_ALL_UNIT_LIST", response.data.UnitList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllUnitList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllUnitList ", err);
        });
    },
    setAllContainerTypeList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_CONTAINER_TYPE_LIST", []);
      CommonService.getAllSplitedOrMergedContainersList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.ContainerTypeList
          ) {
            await commit(
              "SET_ALL_CONTAINER_TYPE_LIST",
              response.data.ContainerTypeList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getAllContainerTypeList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllContainerTypeList ", err);
        });
    },
    setAllSplitedOrMergedContainersList: async (
      { dispatch, commit, state },
      payload,
    ) => {
      await commit("SET_ALL_SPLIT_OR_MERGE_CONTAINER_LIST", []);
      CommonService.getAllSplitedOrMergedContainersList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.SplitedOrMergedContainersList
          ) {
            await commit(
              "SET_ALL_SPLIT_OR_MERGE_CONTAINER_LIST",
              response.data.SplitedOrMergedContainersList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getAllSplitedOrMergedContainersList", response);
        })
        .catch((err) => {
          console.log(
            "Error in getting getAllSplitedOrMergedContainersList ",
            err,
          );
        });
    },
    setAllLocationDetailsFinalList: async (
      { dispatch, commit, state },
      payload,
    ) => {
      await commit("SET_ALL_LOCATION_DETAILS_FINAL_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.LocationDetailsFinalList
          ) {
            await commit(
              "SET_ALL_LOCATION_DETAILS_FINAL_LIST",
              response.data.LocationDetailsFinalList,
            );
          } else {
            // console.log(response.data);
          }
          console.log("getAllLocationDetailsFinalList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllLocationDetailsFinalList ", err);
        });
    },

    setAllAirPortDepartureList: async (
      { dispatch, commit, state },
      payload,
    ) => {
      await commit("SET_ALL_AIRPORT_DEPARTURE_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.AirPortDepartureList
          ) {
            await commit(
              "SET_ALL_AIRPORT_DEPARTURE_LIST",
              response.data.AirPortDepartureList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getAllAirPortDepartureList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllAirPortDepartureList ", err);
        });
    },
    setAllAirPortDestinationList: async (
      { dispatch, commit, state },
      payload,
    ) => {
      await commit("SET_ALL_AIRPORT_DESIGNATION_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.AirPortDestinationList
          ) {
            await commit(
              "SET_ALL_AIRPORT_DESIGNATION_LIST",
              response.data.AirPortDestinationList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getAllAirPortDestinationList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllAirPortDestinationList ", err);
        });
    },

    setAllPORList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_POR_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.PORList
          ) {
            await commit("SET_ALL_POR_LIST", response.data.PORList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllPORList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllPORList ", err);
        });
    },
    setAllPODList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_POD_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.PODList
          ) {
            await commit("SET_ALL_POD_LIST", response.data.PODList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllPODList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllPODList ", err);
        });
    },
    setAllPOLList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_POL_LIST", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.POLList
          ) {
            await commit("SET_ALL_POL_LIST", response.data.POLList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllPOLList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllPOLList ", err);
        });
    },
    setAllContractList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_CONTRACT_LIST", []);
      NodeLockPannelService.getContractList(payload)
        .then(async (response) => {
          console.log(response.data);
          if (response.status == 200 && response.data && response.data.data) {
            await commit("SET_ALL_CONTRACT_LIST", response.data.data);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllPOLList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllContractList ", err);
        });
    },

    setAllContractBasedVesselList: async (
      { dispatch, commit, state },
      payload,
    ) => {
      await commit("SET_ALL_CONTRACT_VESSEL_LIST", []);
      NodeLockPannelService.getContractVesselList(payload)
        .then(async (response) => {
          console.log(response.data);
          if (response.status == 200 && response.data && response.data.data) {
            await commit("SET_ALL_CONTRACT_VESSEL_LIST", response.data.data);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllPOLList", response);
        })
        .catch((err) => {
          console.log("Error in getting SET_ALL_CONTRACT_VESSEL_LIST ", err);
        });
    },
    setAllSuccessInvoiceTB: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_SUCCESS_INVOICE_TB", []);
      CommonService.getAllClientList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.InvoiceTypeKeyArr
          ) {
            await commit("SET_ALL_SUCCESS_INVOICE_TB", response.data);
          } else {
            // console.log(response.data);
          }
          // console.log("setAllSuccessInvoiceTB", response);
        })
        .catch((err) => {
          console.log("Error in getting setAllSuccessInvoiceTB ", err);
        });
    },

    setAllRemarkDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_REMARK_DD_LIST", []);
      RemarkService.getAllRemarkList(payload)
        .then(async (response) => {
          if (response.status == 200 && response.data && response.data.data) {
            await commit("SET_ALL_REMARK_DD_LIST", response.data.data);
          } else {
            // console.log(response.data);
          }
        })
        .catch((err) => {
          console.log("Error in getting setAllRemarkDDList ", err);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/module/common.js